export const mcpInfoContent = {
  hero: {
    title: "AI-Powered Family Coordination",
    subtitle: "Model Context Protocol Integration",
    description: "FamilyCast eliminates the mental burden of family coordination by letting AI assistants automatically sync your tasks, calendars, and information across all your apps."
  },
  whyMcp: {
    title: "Why MCP for FamilyCast?",
    cards: [
      {
        title: "The Problem",
        description: "Families juggle multiple disconnected apps—calendars, task lists, meal plans, chore charts. Parents manually sync information across platforms, creating significant mental load."
      },
      {
        title: "Our Solution",
        description: "Model Context Protocol (MCP) enables AI assistants like Claude to automatically pull data from your apps, creating a unified \"source of truth\" for your family. No more manual updates—your AI assistant keeps everything synchronized for you."
      },
      {
        title: "The Vision",
        description: "We believe families deserve the same AI-powered organization tools that big companies use."
      }
    ],
    benefits: [
      {
        iconName: "AutoAwesome",
        title: "AI-Powered Coordination",
        description: "Let Claude and other AI assistants automatically manage your family's tasks, calendars, and information across all your apps."
      },
      {
        iconName: "Cable",
        title: "Universal Integration",
        description: "Connect any app that supports MCP - from task managers to calendars to meal planners - all in one unified system."
      },
      {
        iconName: "Speed",
        title: "Eliminate Manual Work",
        description: "Stop manually syncing information between apps. Your AI assistant keeps everything up-to-date automatically."
      }
    ]
  },
  servers: {
    title: "Available MCP Servers",
    cards: [
      {
        title: "🗂️ Cozi MCP Server",
        description: "Connect your Cozi task lists and shopping lists to AI assistants. Ask Claude to add items, check what's on your grocery list, or manage family to-dos—all through natural conversation.",
        url: "https://dev.familycast.app/mcp/cozi",
        version: "1.0.0",
        status: "Active"
      }
    ],
    footer: "More integrations coming soon: Google Calendar, Notion, Todoist, and more!"
  },
  authMethods: {
    title: "Authentication Methods",
    subtitle: "Choose the authentication method that works best for your setup:",
    methods: [
      {
        title: "API Key",
        icon: "🔑",
        bestFor: "Personal use with Claude Desktop",
        features: [
          "Simple one-time setup",
          "Create in Advanced Settings",
          "Requires mcp:access scope",
          "Revocable anytime"
        ]
      },
      {
        title: "OAuth 2.0",
        icon: "🔐",
        bestFor: "Third-party apps and enterprise",
        features: [
          "Secure delegated access",
          "Automatic token refresh",
          "Scoped permissions",
          "Industry-standard protocol"
        ]
      }
    ]
  },
  setupGuide: {
    title: "Quick Setup Guide",
    steps: [
      "Create an API key in Advanced Settings with the mcp:access scope",
      "Configure Claude Desktop with the MCP server URL and your credentials",
      "Link your accounts (Cozi, calendars, etc.) in FamilyCast Integrations",
      "Start asking Claude to manage your family's tasks and schedules!"
    ]
  },
  pricing: {
    title: "Pricing",
    card: {
      preTitle: "Early Access",
      title: "FREE",
      description: "We're in early access! Get started today with unlimited MCP access. Pricing will be announced before general availability.",
      footer: "Early adopters will receive special pricing and priority support when we launch."
    }
  },
  cta: {
    title: "Ready to Get Started?",
    subtitle: "Set up your MCP servers and let AI handle your family coordination!",
    button: "Read Our Blog"
  },
  footer: {
    mcpDocs: "MCP Documentation",
    docs: "FamilyCast Docs",
    support: "Support",
    copyright: "FamilyCast © "
  }
};
